import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';

const Skills = () => {
	return (
		<div className="row">
			<div className="col-md-6 py-3">
				<p className="py-2 pr-2">
					<span className="titleLogo"><FontAwesomeIcon className="fa-2x pt-2" icon={faPencilAlt} /></span>
					<span className="titleSupport pl-3">Skills</span>
				</p>
				<div className="row text-center">
					<div className="col-md-3 col-3 language">
						<p>PHP</p>
						<p>NodeJS</p>
						<p>NestJS</p>
						<p>React-js</p>
						<p>HTML</p>
						<p>CSS</p>
						<p>Javascript</p>
						<p>Mysql</p>
						<p>MongoDb</p>
					</div>
					<div className="col-md-9 col-9 pr-5 langRange">
						<div className="progress my-2">
							<div className="progress-bar proPHP" role="progressbar"></div>
						</div>
						<div className="progress my-4">
							<div className="progress-bar proNode" role="progressbar"></div>
						</div>
						<div className="progress mt-2">
							<div className="progress-bar proNest" role="progressbar"></div>
						</div>
						<div className="progress mt-4">
							<div className="progress-bar proReact" role="progressbar"></div>
						</div>
						<br />
						<div className="progress mt-2">
							<div className="progress-bar proHTML" role="progressbar"></div>
						</div>
						<br />
						<div className="progress">
							<div className="progress-bar proCSS" role="progressbar"></div>
						</div>
						<br />
						<div className="progress mt-1">
							<div className="progress-bar proJS" role="progressbar"></div>
						</div>
						<br />
						<div className="progress mt-1">
							<div className="progress-bar promysql" role="progressbar"></div>
						</div>
						<br />
						<div className="progress mt-1">
							<div className="progress-bar promongo" role="progressbar"></div>
						</div>
					</div>
				</div>
			</div>
			<div className="col-md-6 py-3">
				<p className="py-2 pr-2">
					<span className="titleLogo"><FontAwesomeIcon className="fa-2x pt-2" icon={faPencilAlt} /></span>
					<span className="titleSupport pl-3">Extra</span>
				</p>
				<div className="row text-center">
					<div className="col-md-3 col-3 language">
						<p>AJAX</p>
						<p>JSON</p>
						<p>AWS</p>
						<p>Axios</p>
						<p>Express</p>
						<p>Apache</p>
						<p>Socket Io</p>
						<p>RMQP</p>
						<p>Redis</p>
					</div>
					<div className="col-md-9 col-9 pr-5 langRange">
						<div className="progress my-2">
							<div className="progress-bar proPHP" role="progressbar"></div>
						</div>
						<div className="progress my-4">
							<div className="progress-bar proNode" role="progressbar"></div>
						</div>
						<div className="progress mt-4">
							<div className="progress-bar proReact" role="progressbar"></div>
						</div>
						<br />
						<div className="progress mt-2">
							<div className="progress-bar proHTML" role="progressbar"></div>
						</div>
						<br />
						<div className="progress">
							<div className="progress-bar proCSS" role="progressbar"></div>
						</div>
						<br />
						<div className="progress">
							<div className="progress-bar proCSS" role="progressbar"></div>
						</div>
						<br />
						<div className="progress mt-2">
							<div className="progress-bar proCSS" role="progressbar"></div>
						</div>
						<div className="progress mt-4">
							<div className="progress-bar proRMQP" role="progressbar"></div>
						</div>
						<div className="progress mt-4">
							<div className="progress-bar proRedis" role="progressbar"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

	)
}

export default Skills;